import React from 'react';
import { withRouter } from 'react-router-dom';
import BCrumb from 'Components/Bcrumb/BCrumb.jsx';
import Layout from 'Components/layout/Layout.jsx';
import './ErrorPage.scss';
import { useGetTopicQuery } from 'Services/api';

const ErrorPage = () => {
    const { error } = useGetTopicQuery();

    return (
        <Layout>
            <BCrumb />
            <div className="error-page">
                <h1>Ups!, something went wrong!</h1>
                <p>{error}</p>
            </div>
        </Layout>
    );
};

export default withRouter(ErrorPage);
